/* RS footer (sections/rs-footer.liquid): link lists as an accordion on mobile.
   The menus are rendered open (so they work without this script); on mobile this closes them and a tap
   on a heading opens one, on desktop they stay open and the headings are not clickable. In the theme
   editor, selecting a menu block opens it. */
if (!customElements.get('rs-footer')) {
  customElements.define(
    'rs-footer',
    class RsFooter extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-accordion')) return;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.onMedia = () => this.sync();
        this.onClick = (event) => {
          const summary = event.target.closest('.rs-ft__summary');
          if (summary && this.contains(summary) && !this.mobile.matches) event.preventDefault();
        };
        this.onBlockSelect = (event) => {
          const details = event.target.querySelector && event.target.querySelector('.rs-ft__acc');
          if (details && this.contains(details)) details.open = true;
        };
        this.mobile.addEventListener('change', this.onMedia);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.setAttribute('data-accordion-ready', '');
        this.sync();
      }

      disconnectedCallback() {
        if (!this.mobile) return;
        this.mobile.removeEventListener('change', this.onMedia);
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      sync() {
        const isMobile = this.mobile.matches;
        this.querySelectorAll('.rs-ft__acc').forEach((details) => {
          details.open = !isMobile;
          const summary = details.querySelector('.rs-ft__summary');
          if (!summary) return;
          if (isMobile) {
            summary.removeAttribute('tabindex');
          } else {
            summary.setAttribute('tabindex', '-1');
          }
        });
      }
    }
  );
}
